import Login from "./pages/login/login";
import Orders from "./pages/orders/orders";
import ProductsPage from "./pages/products/productsPage";
import CatalogsPage from "./pages/catalogs/catalogs";
import SettingsPage from "./pages/settings/settingsPage";
import ConstructorPage from "./pages/constructor/constructorPage";

const publicRoutes = [
    {
        link: "/",
        Component: <Login/>
    },
    {
        link: "/login",
        Component: <Login/>
    }
]
const authRoutes = [
    {
        link: "/orders",
        Component: <Orders/>
    },
    {
        link: "/products",
        Component: <ProductsPage/>
    },
    {
        link: "/constructor",
        Component: <ConstructorPage/>
    },
    {
        link: "/catalogs",
        Component: <CatalogsPage/>
    },
    {
        link: "/settings",
        Component: <SettingsPage/>
    }
]

export {
    publicRoutes,
    authRoutes,
}

